
const card_config=[
    {title: "Submit Data", description:"Submit Experiment and Files Metadata for rare disease patients", href:"#/submission"},
    {title: "Manage your data", description:" Browse and Manage your data across data owner and groups", href:"#/management"},
    ];



const submission_cards_config = [
    {title: "Submit Experiments", description:"Submit one or more experiments for the participants already submitted to our platform", href:"#/selectgroup"},
    {title: "Submit Files", description:"Submit the metadata for the submitted files. This is the final data submission step ", href:"#/selectexperiments"},
];

export default card_config;
export {submission_cards_config}
